import { format } from "date-fns";
import React from "react";

import {
  eachDayOfWeek,
  FirstDayOfWeek,
  DEFAULT_FIRST_DAY_OF_WEEK,
} from "../lib/datetime";
import { stylex } from "./stylex";
import { Text } from "./text";

interface WeekDatesProps {
  firstDayOfWeek?: FirstDayOfWeek;
  date?: Date;
}

export const WeekDates = (props: WeekDatesProps) => {
  const { date = new Date(), firstDayOfWeek = DEFAULT_FIRST_DAY_OF_WEEK } =
    props;
  const dates = eachDayOfWeek(date, firstDayOfWeek);

  return (
    <div style={styles("container")}>
      {dates.map((date) => (
        <div key={date.toISOString()} style={styles("dateWrapper")}>
          <Text fontSize="sm">{format(date, "EEEEEE")}</Text>
        </div>
      ))}
    </div>
  );
};

const styles = stylex.create({
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
  },
  dateWrapper: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    boxSizing: "border-box",
    justifyContent: "center",
    alignItems: "center",
    padding: 1,
  },
});
